// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divider {
  color: lightgrey;
  margin: 0 1px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/controls/button-divider/button-divider.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;AACF","sourcesContent":[".divider {\n  color: lightgrey;\n  margin: 0 1px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
